 const normalize = (d: Date) =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate());

  export function isToday(date: Date) {
    const newDate = normalize(new Date(date));
    const today = normalize(new Date());

    return newDate.getTime() === today.getTime();
  }

export const parseDateString = (dateStr: string) => {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export function compareDate(dateA: Date, dateB: string) {
    const newDate = normalize(dateA);
    const newDate2 = normalize(parseDateString(dateB));

    return newDate.getTime() === newDate2.getTime();
}

export const getDaysInMonth = (year: number, month: number): number => {
  return new Date(year, month + 1, 0).getDate();
};

export const addMonths = (date: Date, months: number): Date => {
  return new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
};

export const addDays = (date: Date, days: number): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
};

export const subDays = (date: Date, days: number): Date => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - days);
};

export const formatDayMonth = (date: Date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${day}/${month}`;
};

export function dayOfMonth(data: Date) {
    const ano = data.getFullYear();
    const mes = data.getMonth() + 1;
    return new Date(ano, mes, 0).getDate();
}

export function getWeeksInMonth(year: number, month: number): number {
  const firstWeekDayIndex = new Date(year, month, 1).getDay();
  const daysInCurrentMonth = getDaysInMonth(year, month);
  return Math.ceil((firstWeekDayIndex + daysInCurrentMonth) / 7);
}

export function removerPrefixo(str: string) {
  return str.split(' - ').slice(1).join(' - ');
}